import { render } from "./TvmMyVehicle.vue?vue&type=template&id=5f04e1c0&scoped=true"
import script from "./TvmMyVehicle.vue?vue&type=script&lang=js"
export * from "./TvmMyVehicle.vue?vue&type=script&lang=js"

import "./TvmMyVehicle.vue?vue&type=style&index=0&id=5f04e1c0&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f04e1c0"]])

export default __exports__